module.exports = __webpack_public_path__ + "img/map_arrow.d5c5752e.png";